import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import { Paper, Button, Grid, TextField, Tooltip, } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import EditIcon from '@material-ui/icons/Edit';
import InfoIcon from '@material-ui/icons/Info';
import { getPermissionKey } from "..";
import { checkApiStatus, checkPermission } from '../../utils_v2';
import { PageLoader, STableLoader } from '../../shared_elements';
import { assetTypeValues, } from '../../../constants';
import { globalGetService, globalPutService, globalPostService } from '../../../globalServices';
import { trackActivity } from '../../../utils/mixpanel';
import { mtInstance, titanAviInstance } from '../../../shared/components';
import { usePageTitleOffset } from '../../elements/CollapsibleSideNav';
const AircraftBuildInfoOperationalData = ({ params, assetInfoData }) => {
    const navTitleOffset = usePageTitleOffset('techSpecsNavCollapsed');
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [isEdit, setEdit] = useState(false);
    const [buildOperationInfo, setBuildOperationInfo] = useState({});
    const [pltConstants, setPltConstants] = useState([]);
    const [error, setError] = useState({});
    useEffect(() => {
        getBuildOperationalInfo('skeletonLoader');
        globalPostService('console/get-constants/', { constant_types: ['config_install'] })
            .then(response => {
                if (checkApiStatus(response)) {
                    setPltConstants(response.data.data)
                }
            })
    }, []);
    const getBuildOperationalInfo = (loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(`console/v2/asset/${params.type}/${params.aircraft_slug}/build_ops_config_details/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setBuildOperationInfo(response.data.data);
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            })
    }
    const onFieldChange = (key, value) => { setBuildOperationInfo({ ...buildOperationInfo, [key]: value }); }
    const onEditBuildOperationalInfo = () => {
        let validationInputs = {}
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            let payload = Object.assign({}, buildOperationInfo)
            payload = {
                ...payload,
                airstair : buildOperationInfo?.airstair?.value ?? null
            }
            globalPutService(`console/v2/asset/${params.type}/${params.aircraft_slug}/build_ops_config_details/`, payload)
                .then(response => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        trackActivity('Console Management', {data:JSON.stringify(payload), page_title: 'Aircraft Aquisition & Other Details', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited Aircraft Aquisition & Other Details data from Edit Aircraft Aquisition & Other Details form' });
                        setEdit(false);
                    }
                    setLoading(false);
                })
        } else {
            setError(validationInputs)
        }
    }

    return (
        <div style={{ position: 'relative' }}>
            <div className="console-forms-fields" style={{ height: `${(window.innerHeight - (isEdit ? 275 : 230)) - navTitleOffset}px`, padding: '0px 10px' ,overflow:"auto"}}>
                <p style={{ textAlign: 'right', height: '20px' }}>
                    {checkPermission('technical_specs', getPermissionKey(params.type), 'U') && !isEdit ?
                        <span style={{ cursor: 'pointer' }}>
                            <EditIcon onClick={() => { setEdit(true); }} fontSize="small" color='primary' />
                        </span> : null
                    }
                </p>
                {skeletonLoader ? < STableLoader count={3} size={7}/> : <>
                    <Grid container spacing={1}>
                        <Grid item md={3}>
                            <TextField
                                disabled={!isEdit}
                                name='cargo_compartment_fire_compliance'
                                label={
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        Cargo Compartment - Fire Compliance
                                    </span>
                                }
                                value={buildOperationInfo?.cargo_compartment_fire_compliance || ''}
                                inputProps={{ maxLength: 255 }}
                                fullWidth
                                margin="normal"
                                onChange={(e) => { onFieldChange('cargo_compartment_fire_compliance', e.target.value); }}
                                InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={3}>
                            {(() => {
                                return (
                                    <Autocomplete
                                        disabled={!isEdit}
                                        options={pltConstants.filter(optionItem => optionItem.type === 'config_install')}
                                        getOptionLabel={option => option?.label}
                                        name="airstair"
                                        value={buildOperationInfo?.airstair || ''}
                                        onChange={(e, value) => { onFieldChange('airstair', value); }}
                                        renderInput={params => <TextField {...params} label="Airstair" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />} />
                                )
                            })()}
                        </Grid>
                        <Grid item md={3}>
                            <TextField
                                disabled={!isEdit}
                                name='door_configuration'
                                label={
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        Door Configuration
                                    </span>
                                }
                                value={buildOperationInfo?.door_configuration || ''}
                                inputProps={{ maxLength: 255 }}
                                fullWidth
                                margin="normal"
                                onChange={(e) => { onFieldChange('door_configuration', e.target.value); }}
                                InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={3}>
                            <TextField
                                disabled={!isEdit}
                                name='elementary_surveillance_els_enhanced'
                                label={
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        Elementary Surveillance (ELS)/Enhanced Surveillance (EHS)
                                    </span>
                                }
                                value={buildOperationInfo?.elementary_surveillance_els_enhanced || ''}
                                inputProps={{ maxLength: 255 }}
                                fullWidth
                                margin="normal"
                                onChange={(e) => { onFieldChange('elementary_surveillance_els_enhanced', e.target.value) }}
                                InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={3}>
                            <TextField
                                disabled={!isEdit}
                                name='adsb'
                                label={
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        Automatic Dependent Surveillance Broadcast (ADS-B)
                                    </span>
                                }
                                value={buildOperationInfo?.adsb || ''}
                                inputProps={{ maxLength: 255 }}
                                fullWidth
                                margin="normal"
                                onChange={(e) => { onFieldChange('adsb', e.target.value) }}
                                InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={3}>
                            <TextField
                                disabled={!isEdit}
                                name='landing_capability'
                                label='Landing Capability Current'
                                value={buildOperationInfo?.landing_capability || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 25 }}
                                onChange={(e) => onFieldChange('landing_capability', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={3}>
                            <TextField
                                disabled={!isEdit}
                                name='autoland_capabilities_limitation'
                                label='Autoland Capabilities Limitation'
                                value={buildOperationInfo?.autoland_capabilities_limitation || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 255 }}
                                onChange={(e) => onFieldChange('autoland_capabilities_limitation', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={3}>
                            <TextField
                                disabled={!isEdit}
                                name='noise_category'
                                label='Noise Category'
                                value={buildOperationInfo?.noise_category || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 255 }}
                                onChange={(e) => onFieldChange('noise_category', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={3}>
                            <TextField
                                disabled={!isEdit}
                                name='etops_aircraft_model_certification'
                                label={
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        ETOPS Aircraft Model Certification
                                        <Tooltip title="Specifiy the Certification Standard.For Eg 60min or 120min or 180min." placement='right'  ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip>
                                    </span>
                                }
                                value={buildOperationInfo?.etops_aircraft_model_certification || ''}
                                inputProps={{ maxLength: 25 }}
                                fullWidth
                                margin="normal"
                                onChange={(e) => { onFieldChange('etops_aircraft_model_certification', e.target.value); setError({ ...error, 'acquisition_date': '' }) }}
                                InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={3}>
                            <TextField
                                disabled={!isEdit}
                                name='etops_current_config_capacity_cmp_revision'
                                label={
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        ETOPS Current Config Capacity
                                        <Tooltip title="Specifiy the Current Operation Standard.For Eg 60min or 120min or 180min.Note:Certification & Current Operation can be different" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip>
                                    </span>
                                }
                                value={buildOperationInfo?.etops_current_config_capacity_cmp_revision || ''}
                                fullWidth
                                inputProps={{ maxLength: 25 }}
                                margin="normal"
                                onChange={(e) => { onFieldChange('etops_current_config_capacity_cmp_revision', e.target.value) }}
                                InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={3}>
                            <TextField
                                disabled={!isEdit}
                                name='etops_operational_standard'
                                label='ETOPS Operational Standard'
                                value={buildOperationInfo?.etops_operational_standard || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 25 }}
                                onChange={(e) => onFieldChange('etops_operational_standard', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={3}>
                            <TextField
                                disabled={!isEdit}
                                name='act_provisions'
                                label={
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        ACT Provisions
                                        <Tooltip title="Is asset equipped with ACT Provision-Yes/No/NA" placement='right' style={{ maxWidth: 100 }} ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip>
                                    </span>
                                }
                                value={buildOperationInfo?.act_provisions || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 10 }}
                                onChange={(e) => onFieldChange('act_provisions', e.target.value)}
                                InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={3}>
                            <TextField
                                disabled={!isEdit}
                                name='rvsm'
                                label={
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        RVSM (Reduced Vertical Separation Minimum)
                                        <Tooltip title="Specifiy 'Complied' or 'Not Complied'" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip>
                                    </span>
                                }
                                value={buildOperationInfo?.rvsm || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 25 }}
                                onChange={(e) => onFieldChange('rvsm', e.target.value)}
                                InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={3}>
                            <TextField
                                disabled={!isEdit}
                                name='cockpit_door_surveillance_system'
                                label={
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        Cockpit Door Surveillance System
                                        <Tooltip title="Specifiy Yes/No/NA'" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip>
                                    </span>
                                }
                                value={buildOperationInfo?.cdss || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 10 }}
                                onChange={(e) => onFieldChange('cdss', e.target.value)}
                                InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={6}>
                            <TextField
                                disabled={!isEdit}
                                name='etops'
                                label={
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        ETOPS (Extended Range Twin Engine Operations)
                                        <Tooltip title="Specifiy 'YES' or 'NO'" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip>
                                    </span>
                                }
                                value={buildOperationInfo?.etops || ''}
                                fullWidth
                                margin="normal"
                                onChange={(e) => onFieldChange('etops', e.target.value)}
                                InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                variant='outlined'
                            />
                        </Grid>
                        {/* {(titanAviInstance || avationPlcInstance || mtInstance) ? */}
                        <>
                            <Grid item md={3}>
                                {(() => {
                                    const options = ['Standard','Winglets','Sharklets',...(mtInstance ? ['Split Scimitar Winglets'] : [])];
                                    return (
                                        <Autocomplete
                                            disabled={!isEdit}
                                            options={options}
                                            getOptionLabel={option => option}
                                            name="winglets_sharklets"
                                            value={buildOperationInfo?.winglets_sharklets || ''}
                                            onChange={(e, value) => { onFieldChange('winglets_sharklets', value); }}
                                            renderInput={params => <TextField {...params} label="Winglets/Sharklets" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    )
                                })()}
                            </Grid>
                            <Grid item md={3}>
                                {(() => {
                                    let options = ['Large', 'Small'];
                                    return (
                                        <Autocomplete
                                            disabled={!isEdit}
                                            options={options}
                                            getOptionLabel={option => option}
                                            name="aft_door"
                                            value={buildOperationInfo?.aft_door || ''}
                                            onChange={(e, value) => { onFieldChange('aft_door', value); }}
                                            renderInput={params => <TextField {...params} label="AFT Lower Deck Cargo Door" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />} />
                                    )
                                })()}
                            </Grid>
                            <Grid item md={3}>
                                {(() => {
                                    let options = ['Powered', 'Non-Powered',...(mtInstance ? ['No'] : [])];
                                    return (
                                        <Autocomplete
                                            disabled={!isEdit}
                                            options={options}
                                            getOptionLabel={option => option}
                                            name="cargo_loading_system"
                                            value={buildOperationInfo?.cargo_loading_system || ''}
                                            onChange={(e, value) => { onFieldChange('cargo_loading_system', value); }}
                                            renderInput={params => <TextField {...params} label={titanAviInstance ?"Cargo Loading System Main Deck" : "Cargo Loading System"} margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    )
                                })()}
                            </Grid>
                            {mtInstance ? null :   <Grid item md={3}>
                                {(() => {
                                    let options = ['Powered', 'Non-Powered'];
                                    return (
                                        <Autocomplete
                                            disabled={!isEdit}
                                            options={options}
                                            getOptionLabel={option => option}
                                            name="cargo_loading_system_lower"
                                            value={buildOperationInfo?.cargo_loading_system_lower || ''}
                                            onChange={(e, value) => { onFieldChange('cargo_loading_system_lower', value); }}
                                            renderInput={params => <TextField {...params} label="Cargo Loading System-Lower Deck" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    )
                                })()}
                            </Grid>}
                          
                            {mtInstance ? null : <Grid item md={3}>
                                {(() => {
                                    let options = ['Degrees C', 'Fahrenheit F'];
                                    return (
                                        <Autocomplete
                                            disabled={!isEdit}
                                            options={options}
                                            getOptionLabel={option => option}
                                            name="cockpit_temperature"
                                            value={buildOperationInfo?.cockpit_temperature || ''}
                                            onChange={(e, value) => { onFieldChange('cockpit_temperature', value); }}
                                            renderInput={params => <TextField {...params} label="Cockpit Temperature" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    )
                                })()}
                            </Grid>}

                            {mtInstance?null :  <Grid item md={3}>
                                <TextField
                                    disabled={!isEdit}
                                    name='cockpit_display'
                                    label='Cockpit Display Type'
                                    value={buildOperationInfo?.cockpit_display || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('cockpit_display', e.target.value.trimStart())}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>}
                            
                           
                            {/* <Grid item md={3}>
                                {(() => {
                                    let options = ['Kilograms', 'Pounds'];
                                    return (
                                        <Autocomplete
                                            disabled={!isEdit}
                                            options={options}
                                            getOptionLabel={option => option}
                                            name="cockpit_fuel_indication"
                                            value={buildOperationInfo?.cockpit_fuel_indication || ''}
                                            onChange={(e, value) => { onFieldChange('cockpit_fuel_indication', value); }}
                                            renderInput={params => <TextField {...params} label="Cockpit Fuel Indications" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    )
                                })()}
                            </Grid> */}
                            <Grid item md={3}>
                                {(() => {
                                    let options = ['Yes', 'No'];
                                    return (
                                        <Autocomplete
                                            disabled={!isEdit}
                                            options={options}
                                            getOptionLabel={option => option}
                                            name="reinforced_cockpit_door"
                                            value={buildOperationInfo?.reinforced_cockpit_door || ''}
                                            onChange={(e, value) => { onFieldChange('reinforced_cockpit_door', value); }}
                                            renderInput={params => <TextField {...params} label="Reinforced Cockpit Door " margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    )
                                })()}
                            </Grid>
                            <Grid item md={3}>
                                {(() => {
                                    let options = ['FAA', 'EASA'];
                                    return (
                                        <Autocomplete
                                            disabled={!isEdit}
                                            options={options}
                                            getOptionLabel={option => option}
                                            name="afm_approval"
                                            value={buildOperationInfo?.afm_approval || ''}
                                            onChange={(e, value) => { onFieldChange('afm_approval', value); }}
                                            renderInput={params => <TextField {...params} label="AFM Approval " margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    )
                                })()}
                            </Grid>
                            <Grid item md={3}>
                                <TextField
                                    disabled={!isEdit}
                                    name='wheel_manufacturer'
                                    label='Wheels & Brakes Manufacturer'
                                    value={buildOperationInfo?.wheel_manufacturer || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('wheel_manufacturer', e.target.value.trimStart())}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={3}>
                                <TextField
                                    disabled={!isEdit}
                                    name='brake_type'
                                    label="Brake Type"
                                    value={buildOperationInfo?.brake_type || null}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('brake_type', e.target.value.trimStart())}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={3}>
                                <TextField
                                    disabled={!isEdit}
                                    name='tcas'
                                    label="TCAS Change 7.1"
                                    value={buildOperationInfo?.tcas || null}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('tcas', e.target.value.trimStart())}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={3}>
                                <TextField
                                    disabled={!isEdit}
                                    name='future_navigation_system'
                                    label="Future Aircraft Navigation Systems"
                                    value={buildOperationInfo?.future_navigation_system || null}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('future_navigation_system', e.target.value.trimStart())}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                        </>
                        {/* : null} */}



                    </Grid>
                </>}
            </div>
            {isEdit ?
                <Paper square style={{ padding: '10px', borderTop: '1px solid #d7d7d7' }}>
                    <ul className="list-inline" style={{textAlign: "right"}}>
                        <li className="list-inline-item">
                            <Button onClick={() => { setError(''); setEdit(false); getBuildOperationalInfo() }} color="primary" size='small' variant="outlined">Cancel</Button>
                        </li>
                        <li className="list-inline-item">
                            <Button onClick={onEditBuildOperationalInfo} color="primary" size='small' variant="contained">SAVE</Button>
                        </li>
                    </ul>
                </Paper> : null
            }
            {isLoading ? <PageLoader /> : null}
        </div>
    )
}
export default withRouter(AircraftBuildInfoOperationalData);